import { api } from '@/scripts/api';

export const MDFAgencyDenyRequestService = {
    post(accountId, fundRequestId, payload) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/fund-requests/vendor-account/${accountId}/requests/${fundRequestId}/deny-funds`;

            api.post(service, payload)
                .then(resolve)
                .catch(reject);
        });
    },
}
